const CommentReducer = ( state = { 
    paginationCount:20, 
    next : null, 
    previous : null, 
    rs : null, 
    query : '', 
  }, action ) => {
    switch (action.type) {
        case "CommentSetRS":
            state = {
              ...state,
              next : action.payload.next,
              previous : action.payload.previous,
              rs:action.payload.rs,
              query : action.payload.query,
            }
            break;
        default:
            break;

    }
    return state;
};

export default CommentReducer;



// WEBPACK FOOTER //
// ./src/App/store/comment/comment.js